if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* Club Flags eyelets add-on (fixed Flag Type selectors) */
(function () {
  var SEWN = '100 x 150cm Flag (sewn on the edges)';

  function wrap() { return document.getElementById('cf-eyelets-addon'); }
  function check() { return document.getElementById('cf-eyelets-check'); }

  function selectedFlagType() {
    // Dawn / Club Flags uses radios named like "Flag Type-1", not options[Flag Type]
    var checked = document.querySelector('fieldset.product-form__input input[type="radio"]:checked');
    if (checked && checked.value) return checked.value.trim();
    var byValue = document.querySelector('fieldset.product-form__input input[type="radio"][value="' + SEWN.replace(/"/g, '\\"') + '"]');
    // also try any checked radio whose name starts with Flag Type
    var ft = document.querySelector('input[type="radio"][name^="Flag Type"]:checked');
    if (ft && ft.value) return ft.value.trim();
    return checked ? String(checked.value || '').trim() : '';
  }

  function sync() {
    var w = wrap();
    var c = check();
    if (!w || !c) return;
    var sewn = (w.getAttribute('data-sewn-value') || SEWN).trim();
    var show = selectedFlagType() === sewn;
    if (show) {
      w.removeAttribute('hidden');
      w.style.display = '';
    } else {
      w.setAttribute('hidden', '');
      c.checked = false;
    }
    document.querySelectorAll('.shopify-payment-button').forEach(function (btn) {
      btn.style.display = (show && c.checked) ? 'none' : '';
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (
      e.target.id === 'cf-eyelets-check' ||
      (e.target.matches && e.target.matches('input[type="radio"]')) ||
      e.target.closest('variant-selects') ||
      e.target.closest('fieldset.product-form__input')
    ) {
      sync();
    }
  });

  // Variant picks often dispatch custom events
  document.addEventListener('variant:change', sync);
  document.addEventListener('DOMContentLoaded', sync);
  // run now + after a tick (variant UI hydrates late)
  sync();
  setTimeout(sync, 100);
  setTimeout(sync, 500);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var w = wrap();
    var c = check();
    if (!w || !c || w.hasAttribute('hidden') || !c.checked) return;
    var vid = w.getAttribute('data-variant-id');
    if (!vid) return;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value || '1', 10) : 1;
    setTimeout(function () {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty }] })
      }).then(function () {
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (err) {}
      }).catch(function () {});
    }, 500);
  }, true);
})();

